module.exports = __webpack_public_path__ + "static/openPlusPic-784e8e82e408bb8211d9a1ca92a61f48.png";